import API from "../utils/api";

export const getFrasersPaymentsApi = async (params) => {
    const response = await API.get("order/frasers-plus-payments", { params });
    return { response };
};

export const getFrasersPaymentByIdApi = async (id) => {
    const response = await API.get(`order/frasers-plus-payments/${id}`);
    return { response };
};

export const refreshFrasersPaymentApi = async (id) => {
    const response = await API.post(`order/frasers-plus-payments/${id}/refresh`);
    return { response };
};

// orderId is the marketplace orders.id. Emails the customer the same
// "Pay with Frasers Plus" link the thank-you page showed.
export const sendFrasersReminderApi = async (orderId) => {
    const response = await API.post(`order/frasers-plus-reminders/${orderId}/send`);
    return { response };
};
